<template>
	<div class="content-box second">
		<div class="qr-code">
			<div class="img_qr-wrapper">
        <qrcode-vue v-if="otpauth" :value="otpauth" :size="110" level="H" background="#ffffff" foreground="#000000" />
      </div>
        <!-- <button class="btn btn-show-recovery-code" @click="ShowRecoveryCode = !ShowRecoveryCode">
          <span v-if="!ShowRecoveryCode">{{ $t('account.modal.agreement_otp.view_secret_key') }}</span>
          <span type="text" class="recovery-code" name="recovery_code" v-if="ShowRecoveryCode">{{ key2fa }}</span>
        </button> -->
        <div class="btn-show-recovery-code">{{key2fa}}</div>
        <span class="scan_qrcode_des">{{$t('account.otp.qr_text')}}</span>
		</div>
	</div>
</template>
<script>
	import rf from '@/request/RequestFactory'
  import QrcodeVue from 'qrcode.vue'
  import { mapState } from 'vuex';

  export default {
    components: {
      QrcodeVue,
    },
    props: {
      user: {
        type: Object,
        default: () => ({}),
      }
    },
    data() {
      return {
        urlQR : '',
        key2fa: '',
        otpauth: '',
        ShowRecoveryCode: false,
      }
    },
    methods : {
      getQRCodeGoogleUrl() {
        rf.getRequest('UserRequest').getQRCodeGoogleUrl().then(res => {
          this.urlQR = res.url;
          this.key2fa = res.key;
          this.generateOtpauth();
          this.$emit('keyUpdated', this.key2fa);
        });
      },
      generateOtpauth() {
        if (!this.key2fa) return;
        const issuer = encodeURIComponent(process.env.VUE_APP_SHORT_NAME || 'TCX-SPOT');
        const account = this.user?.email ? encodeURIComponent(this.user.email) : '';
        const label = account ? `${issuer}:${account}` : issuer;
        this.otpauth = `otpauth://totp/${label}?secret=${this.key2fa}&issuer=${issuer}`;
      },
    },
    created () {
      this.getQRCodeGoogleUrl();
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/sass/variables';
  .img_qr-wrapper {
    width: 130px;
    height: 130px;
    padding: 10px;
    background: #FFFFFF;
    box-shadow: 0px 3px 8px rgba(51, 51, 51, 0.102);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 20px;
  }
  .scan_qrcode_des {
    font-family: $font-inter-regular;
    color: var(--text-close);
    font-size: 18px;
    line-height: 20px;
  }
  .btn-show-recovery-code {
    text-align: center;
    font-size: 22px;
    line-height: 27px;
    font-family: $font-inter-bold;
    color: var(--text-primary-color);
  }

@media screen and (max-width: 992px) { 
  .scan_qrcode_des {
    font-size: 14px;
    line-height: 16px;
  }
  .btn-show-recovery-code {
    font-size: 16px;
    line-height: 19px;
  }
}
</style>